module.exports = __webpack_public_path__ + "static/media/StefanDerksen-4.e117cd97.jpg";